module.exports = __webpack_public_path__ + "img/02-02-img-03.72038c9c.png";